import { render, staticRenderFns } from "./SeguimientoObservacionDialogComponent.vue?vue&type=template&id=34f0b6e0&scoped=true"
import script from "./SeguimientoObservacionDialogComponent.vue?vue&type=script&lang=js"
export * from "./SeguimientoObservacionDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./SeguimientoObservacionDialogComponent.vue?vue&type=style&index=0&id=34f0b6e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f0b6e0",
  null
  
)

export default component.exports